if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue(event) {
        if (event.target.tagName === 'SELECT' && event.target.selectedOptions.length) {
          const select = event.target;
          const selectedOption = select.selectedOptions[0];
          Array.from(select.options)
            .find((option) => option.getAttribute('selected'))
            ?.removeAttribute('selected');
          selectedOption.setAttribute('selected', 'selected');

          const swatchValue = selectedOption.dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = select
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (selectedDropdownSwatchValue) {
            if (swatchValue) {
              selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
              selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
            } else {
              selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
              selectedDropdownSwatchValue.classList.add('swatch--unavailable');
            }
            selectedDropdownSwatchValue.style.setProperty(
              '--swatch-focal-point',
              selectedOption.dataset.optionSwatchFocalPoint || 'unset'
            );
          }
          const selectedSwatchValue = select.closest('.product-form__input')?.querySelector('[data-selected-swatch-value]');
          if (selectedSwatchValue) {
            const displayValue = selectedOption.dataset.displayValue;
            selectedSwatchValue.textContent = displayValue !== undefined ? displayValue : selectedOption.textContent;
          }
        } else if (event.target.tagName === 'INPUT' && event.target.type === 'radio') {
          const selectedSwatchValue = event.target.closest(`.product-form__input`).querySelector('[data-selected-swatch-value]');
          if (selectedSwatchValue) {
            const displayValue = event.target.dataset.displayValue;
            selectedSwatchValue.textContent = displayValue !== undefined ? displayValue : event.target.value;
          }
        }
      }
    }
  );
}
